import { mapEnumToOptions } from '@abp/ng.core';

export enum CategoryType {
  Standard = "Standard",
  Carousel = "Carousel",
  Featured = "Featured",
  Trending = "Trending",
  Showcase = "Showcase",
  ApiOnly = "ApiOnly",
}

export const categoryTypeOptions = mapEnumToOptions(CategoryType);
